//
//
//
//
//
//
//

export default {
  name: 'switch_account',
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    Styles: function Styles() {
      var _this$value$config = this.value.config,
        _this$value$config$sw = _this$value$config.switch_font_size,
        switch_font_size = _this$value$config$sw === void 0 ? 30 : _this$value$config$sw,
        _this$value$config$sw2 = _this$value$config.switch_color,
        switch_color = _this$value$config$sw2 === void 0 ? '#333333' : _this$value$config$sw2,
        _this$value$config$bu = _this$value$config.button_font_size,
        button_font_size = _this$value$config$bu === void 0 ? 30 : _this$value$config$bu,
        _this$value$config$bu2 = _this$value$config.button_color,
        button_color = _this$value$config$bu2 === void 0 ? '#333333' : _this$value$config$bu2;
      var baseSize = 32; //基准值 16*2 C端即可直接取值

      var switchFontSize = switch_font_size / baseSize;
      var buttonFontSize = button_font_size / baseSize;
      return {
        '--switchFontSize': switchFontSize + 'rem',
        '--switchColor': switch_color || '#333333',
        '--buttonFontSize': buttonFontSize + 'rem',
        '--buttonColor': button_color || '#333333'
      };
    }
  }
};